module.exports = __webpack_public_path__ + "static/media/galerija_2017 (23).46ead31c.jpg";